import * as React from 'react';
import { getHostUrlByEnv, loadScript } from '@/utils';
import { useMemoizedFn } from 'ahooks';
import Cookies from 'js-cookie';
import { decodeUserInfo } from '@mc/encryption';

const { useEffect } = React;

const useGoogleOneTap = () => {
  // oneTap回调
  const handleGoogleOneTapCallback = useMemoizedFn(async ({ credential }) => {
    if (typeof window === 'undefined') return;
    window.open(`${getHostUrlByEnv()}/google-one-tap?credential=${credential}`, '_self');
  });

  // 配置oneTap初始化
  const googleOneTapLogin = useMemoizedFn(() => {
    window['google'].accounts.id.initialize({
      client_id: '53779308283-bgqhd5g489j8vhftkhc1vs89m13t3clr.apps.googleusercontent.com',
      prompt_parent_id: 'id_google_one_tap',
      auto_select: false,
      callback: handleGoogleOneTapCallback,
      cancel_on_tap_outside: false,
      use_fedcm_for_prompt: true,
    });
    // 这行代码不能删，不然 Google one tap 弹窗不会出来
    window['google'].accounts.id.prompt();
  });

  // 加载脚本
  useEffect(() => {
    let isLoadOneTap = true;
    const userInfoCode = Cookies.get('vue_admin_template_user_info');
    const v1Token = Cookies.get('v1_token');
    if (userInfoCode && v1Token) {
      const { uid } = decodeUserInfo(userInfoCode, v1Token);
      if (/^\d*$/.test(uid)) {
        isLoadOneTap = false;
      }
    }

    if (isLoadOneTap) {
      loadScript('https://accounts.google.com/gsi/client', 'google-one-tap')
        .then(googleOneTapLogin)
        .catch(() => {});
    }

    // Notta web登陆后会把 v1_token 储存在 notta.ai 域名下供其他子域名判断登录状态
    // if (document.cookie.indexOf('v1_token') === -1) {
    //   loadScript('https://accounts.google.com/gsi/client', 'google-one-tap')
    //     .then(googleOneTapLogin)
    //     .catch((error) => {});
    // }
  }, [googleOneTapLogin]);
};

export default useGoogleOneTap;
